import BlogCardController from "./BlogCardController";

export default BlogCardController;
